import { render } from "./RolesList.vue?vue&type=template&id=2c0ca50b"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"

import "./RolesList.vue?vue&type=style&index=0&id=2c0ca50b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__